import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import DocumentTitle from 'react-document-title'
import { Relayout, RelayoutItem, RelayoutWrapper } from 'relayout'

import Title from 'components/title'
import CustomersExport from 'components/customers-export'

import styles from './data-page.css'

class DataPage extends Component {

  render() {
    return (
      <DocumentTitle title={'Ecommerce Portal - Time Out - Customer Data'}>
        <div styleName="page">
          <RelayoutWrapper>
            <Relayout>
              <RelayoutItem>
                <Title text="Customer Data" />
              </RelayoutItem>
              <RelayoutItem>
                <CustomersExport />
              </RelayoutItem>
            </Relayout>
          </RelayoutWrapper>
        </div>
      </DocumentTitle>
    )
  }
}

export default CSSModules(DataPage, styles)



/** WEBPACK FOOTER **
 ** ./src/containers/data-page/data-page.js
 **/